import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from './store'
import './util/string.prototypes.js'
import '@mdi/font/css/materialdesignicons.min.css' 
import { sync } from 'vuex-router-sync'
// eslint-disable-next-line import/no-named-default
// import { VeeValidate } from 'vee-validate'
import InputMoney from '@/components/InputMoney'
import JsonExcel from "vue-json-excel"
import ExportExcel from "./components/ExportExcel"
import ExportExcelServer from "./components/ExportExcelServer"
import AppMixin from "./plugins/app-mixins.js"
import CKEditor from '@ckeditor/ckeditor5-vue2'
import VSnackbars from 'v-snackbars'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

Vue.config.productionTip = false
Vue.use(VueViewer)
Vue.use(CKEditor)
Vue.use(AppMixin)
Vue.component("downloadExcel", JsonExcel);
Vue.component("exportExcel", ExportExcel);
Vue.component("exportExcelServer", ExportExcelServer);
Vue.component("v-snackbars", VSnackbars);

sync(store, router)
Vue.component('v-text-money', InputMoney)
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
